<template>
  <div class="dashboard-container">
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <!--<svg-icon icon-class="info-outline" class="info-icon"></svg-icon>-->
            <span style="font-size: 20px;">通知</span>
          </div>
          <div v-for="item in notifyList" :key="item.index" class="text item">
            {{ item.text }}
          </div>
          <div v-for="item in warnList" :key="item.index" class="text item" style="color:red">
            {{ item.text }}
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getInfo } from '@/api/login'
export default {
  name: 'DashboardAdmin',
  components: {},
  data() {
    return {
      notifyList: [
        {
          index: 1,
          text:
            '济明信息查询系统升级完成，如您在使用过程中遇到系统上的问题可以随时咨询济明信息中心人员。'
        },
        {
          index: 2,
          text: '电话：0731-82771527'
        }
      ],
      warnList: [

      ],
      userinfo: []
    }
  },
   created() {
    this.getUser()
  },
  
  methods: {
    getUser() {
      getInfo()
        .then(response => {
          debugger;
          this.userinfo = response.data
          if(this.userinfo.expriedflag == 1){
              var expriedstr = {index:3,text:'您的账户即将过期，过期时间为'+this.userinfo.expried+',如需续期使用，请联系济明医药信息部续费 ——联系电话：0731-82771527'};
              this.warnList.push(expriedstr);
          }
        })
        .catch(() => {
          
        })
    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.dashboard-container {
  position: absolute;
  bottom: 0;
  top: 0;
  width: 100%;
  padding: 20px;
  background-color: #f0f2f5;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}

.clearfix:after {
  clear: both;
}

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}
</style>
